


import React from "react";
import InfoContent from "./InfoContent";
import ImageSection from "./ImageSection";
import FAQBox from "./FAQBox";
// import BadgeSection from "./BadgeSection";
// import LeftSidebar from "./Sidebars/LeftSidebar";

const AboutSection = () => {
  return (
    // <section className="bg-gray-50 py-12 px-4">
    // <section className="bg-gray-50 pt-0 pb-12 px-4">
    <section className="bg-gray-50 pt-8 pb-12 px-4">


      <div className="max-w-screen-xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8  lg:text-left">
        {/* Sol taraf: içerikler + görsel */}
        <div className="lg:col-span-2 flex flex-col items-center space-y-10">
            
          <InfoContent />
          <ImageSection />
        
        </div>

        {/* Sağ taraf: SSS + Rozetler */}
        <aside className="flex flex-col items-center space-y-6">
          <FAQBox />
          {/* <BadgeSection /> */}
        </aside>
      </div>
    </section>
  );
};

export default AboutSection;
